// Source-line candidates for the invoice workflow editor, built from an
// already-loaded supplier order (existing supplierOrdersApi query owner).
// Options carry business labels (order number + product); IDs travel as
// values only.
import {
  getSupplierOrderDisplayNumber,
  type SupplierOrderDto,
} from '../../dto/supplierOrder';
import type { WorkflowInvoiceSourceLineCandidate } from '../../types/workflowInvoice';
import { sourceQuantitySetFromLine } from './workflowInvoiceQuantity';

export function buildPurchaseSourceLineCandidates(
  order: SupplierOrderDto,
): WorkflowInvoiceSourceLineCandidate[] {
  const orderNumber = getSupplierOrderDisplayNumber(order);
  return (order.items || []).map((item) => ({
    sourceOrderLineId: item.id,
    sourceOrderId: order.id,
    orderNumber,
    productName: item.name,
    productVariantId: item.productVariantId ?? null,
    variantLabel: null,
    width: item.width ?? null,
    height: item.height ?? null,
    length: item.length ?? null,
    thickness: item.thickness ?? null,
    sourceQuantitySet: sourceQuantitySetFromLine(item),
  }));
}
